import {environment} from '../config'
const {REACT_APP_SERVER_URL, REACT_APP_SERVER_URL_SOFIA, REACT_APP_API_NIVELES_MATERIAS_OBJETIVOS} = environment;
export const baseApiURL = REACT_APP_SERVER_URL;
export const baseUrlSofia = REACT_APP_SERVER_URL_SOFIA;
export const baseUrlNivelesMateriasObjetivos = REACT_APP_API_NIVELES_MATERIAS_OBJETIVOS;